<div class="order-reference-editor" *ngIf="condition" [formGroup]="detailsFormGroup">

    <div class="row">
        <mat-form-field class="flex-grow">
            <input matInput formControlName="orderReference" name="orderReference" maxlength="255"
                placeholder="{{'orderReference ' | translate: ['tmc-yard.entity.transport.masterdata.firstLoadCarrier.orderReference', translationService.language]}}"
                [maxlength]="255">
        </mat-form-field>
    </div>
</div>
